import {useCallback, useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {getSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";


export default function useProductsMatcherTableItems() {
	const items = useSignal([])
	const isLoading = useSignal(false)
	const total = useSignal(0)
	const hasMore = useSignal(false)
	const offset = useSignal(0)
	const limit = 50

	const loadItems = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.MATCHERS}/products/batch-items`, {
			limit,
			offset: offset.value
		}).then(res => {
			items.value = [...items.value, ...res.items]
			total.value = res.total
			hasMore.value = res.hasMore
			isLoading.value = false
		}).catch(() => {
			isLoading.value = false
		})
	}, [offset.value])

	const loadMore = useCallback(() => {
		if (hasMore.value && !isLoading.value) {
			offset.value += limit
		}
	}, [])

	const reset = useCallback(() => {
		items.value = []
		offset.value = 0
		total.value = 0
		hasMore.value = false
	}, [])

	const removeItem = useCallback((mappingID) => {
		items.value = items.value.filter(item => item.mappingID !== mappingID)
		total.value = Math.max(0, total.value - 1)
	}, [])

	useEffect(() => {
		loadItems()
	}, [offset.value])

	return {
		items: items.value,
		isLoading: isLoading.value,
		total: total.value,
		hasMore: hasMore.value,
		loadMore,
		reset,
		removeItem
	}
}
